// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_AT_RULE_IMPORT_0___ = require("-!../../node_modules/css-loader/dist/cjs.js!vue-context/dist/css/vue-context.css");
var ___CSS_LOADER_AT_RULE_IMPORT_1___ = require("-!../../node_modules/css-loader/dist/cjs.js!../Globals.scss");
var ___CSS_LOADER_AT_RULE_IMPORT_2___ = require("-!../../node_modules/css-loader/dist/cjs.js!vue-virtual-scroller/dist/vue-virtual-scroller.css");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
exports.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
exports.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
// Module
exports.push([module.id, "\n.appRoot[data-v-9eaa75b6]\n{\n\tfont-size: 0px;\n\theight: 100%;\n\twidth: 100%;\n}\n.cursorAttached[data-v-9eaa75b6]\n{\n\tposition: absolute;\n\tborder: 1px solid #000000;\n\tbackground-color: #FFFFEE;\n\twhite-space: pre-wrap;\n\tpadding: 0px 1px;\n\topacity: 0.9;\n\tz-index: 2999999;\n\tfont-size: 16px;\n}\n", ""]);
// Exports
module.exports = exports;
